import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../../../app/theme';

const useStyles = makeStyles(
  {
    radio: {
      fontWeight: '400',
      fontSize: '15px',
      lineHeight: '15px',
      color: color.$13,
    },
    radioInput: {
      fontSize: 15,
    },
  },
  {
    name: 'UserCredit',
  },
);

const UserCredit = ({ conditions, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <FormControl component="fieldset">
      <RadioGroup
        aria-label="default-display"
        name="default-display"
        value={conditions}
        onChange={e => onChange(e?.target?.value)}
      >
        <FormControlLabel
          classes={{
            label: classes.radioInput,
          }}
          value="send"
          control={<Radio color="primary" />}
          label={<div className={classes.radio}>{t('ec.userCreditSend')}</div>}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default UserCredit;
